import { useCopyToClipboard } from "react-use";

import { ModelsColorItem, SectionProps } from "@/types";

import { colorItemVariant, type ColorItemVariantProps } from "./color-item.variants";

export type UseColorItemProps = ColorItemVariantProps &
  SectionProps<ModelsColorItem> & {
    style?: React.CSSProperties;
  };

export const useColorItem = (props: UseColorItemProps) => {
  const { className = "", data, sectionName, style } = props;
  const { hex, cmyk, show, pantone, textColor, contrastBorder } = data;
  const [_, copyToClipboard] = useCopyToClipboard();

  const styles = colorItemVariant({ contrastBorder: contrastBorder ?? false });
  const value = show === "hex" ? `#${hex}` : cmyk;

  return {
    className,
    styles,
    data: { ...data, label: show, value, pantone: show === "cmyk" ? pantone : null },
    backgroundColor: `#${hex}`,
    textColor,
    sectionName,
    copyToClipboard,
    style,
  };
};
